/**
 * Zod v4 is not yet fully compatible with react-hook-form's resolver.
 * When v4 is supported, change this file to use the code from the example.
 *
 * @example
 * const configureZod = () => {
 *   z.config({
 *     customError: (issue: $ZodRawIssue<any>): string => {
 *       const translationKey = `form:alert.validation.zod.${issue.code}`;
 *
 *       if (!exists(translationKey)) {
 *         return issue.message || "Unknown validation error";
 *       }
 *
 *       return t(translationKey);
 *     }
 *   });
 * };
 */
import { exists, t } from "i18next";
import { z } from "zod/v3";

const configureZod = () => {
  z.setErrorMap((issue, ctx) => {
    const translationKey = `form:alert.validation.zod.${issue.code}`;
    if (!exists(translationKey)) {
      return {
        message: ctx.defaultError
      };
    }

    const translatedMessage = t(translationKey);
    return {
      message: translatedMessage
    };
  });
};

export default configureZod;
